
define('ldsh!modules/includes_editor/templates/editor_modal', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-overlay-container">\n  <div class="ed-modal-header ed-opt-toolbar">\n    <div class="btn-toolbar content js-toolbar">\n      <div class="ed-toolgroup">\n        <b title="Guardar cambios" class="ed-c-btn ed-c-btn-default js-save"><span class="ed-icon ed-icon-save"></span><span data-i18n="includeEditor.saveButton" class="ed-c-btn-text">guardar</span></b>\n        </b>\n      </div>\n      <button type="button" class="close js-close" data-dismiss="modal" aria-hidden="true">\n        <i class="ri-close-line"></i>\n      </button>\n    </div>\n  </div>\n  <div class="ed-opt-content">\n    <div class="row editor-include">\n      <textarea id="htmlEditor" class="js-editor"></textarea>\n    </div>\n  </div>\n</div>';

}
return __p
};});

